module.exports = __webpack_public_path__ + "img/threePic.1a42ff69.png";